<div #globe id="globe">
    <div id="svgContainer" fxFlex.lt-md="300px" class="legend-container" *ngIf="legendTicks.length">
        <div class="legend-title" [innerHTML]="legendTitle"></div>
        <div class="legend-gradient" [style.background]="legendGradientBackground"></div>
        <div class="legend-ticks">
            <div class="legend-tick" *ngFor="let tick of legendTicks" [style.left]="tick.left">
                <div class="legend-tick-mark"></div>
                <div class="legend-tick-label">{{ tick.label }}</div>
            </div>
        </div>
    </div>
    <div *ngIf="activeComponent != null" class="display-dialog">
        <div class="dialog">
            <div *ngComponentOutlet="activeComponent"></div>
        </div>
    </div>
</div>
<button class="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_trash" id="polygon-deletion" title="Delete"
    (click)="deleteAllPolygons()"></button>
<button class="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_reset" id="reset-default-view" title="Reset Zoom"
    (click)="onResetMapView()"></button>
<div class="sticky-note" *ngIf="drawModeActiveTooltip">
    <div class="polygon-close-button" (click)="closePolygonTooltip()">x</div>
    Define a free-form polygon to select and download data. To draw a polygon, click on the map to define each corner and double click to complete. To draw additional polygons, first click on the drawing mode icon each time. To deactivate the drawing mode, simply click on the trash icon
</div>
<select class="projection" name="projection" (change)='projectionChange($event.target.value)'>
    <option value="globe">Globe</option>
    <option value="equalEarth">Equal Earth</option>
</select>

<div class="toggle-wrap" id="boundaries-checkbox" title="Show/hide area boundaries">
    <input type="checkbox" class="toggle" (click)="boundaryVisibilityChange($event.target.checked)">
</div>
